import { render } from "./app-layout.vue?vue&type=template&id=4df9304a"
import script from "./app-layout.vue?vue&type=script&lang=js"
export * from "./app-layout.vue?vue&type=script&lang=js"

import "./app-layout.vue?vue&type=style&index=0&id=4df9304a&lang=scss"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__